import { Injectable, Signal, computed, signal } from '@angular/core';
import { IIqStyleProcessorStateService, IqCssClassnames } from '../../models';
import {
    IDatiqRulesData,
    IDatiqRulesRule,
    IqRulesService,
} from '@dat/iq-proxy';
import { uniq, flatten, isObject } from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class IqStyleProcessorStateService
    implements IIqStyleProcessorStateService
{
    constructor(private _rule: IqRulesService) {}

    show(rules: IDatiqRulesRule[]): Signal<boolean> {
        return this._rule.passed(rules);
    }

    appliedClasses(
        classes: IqCssClassnames,
    ): Signal<[string, string[]][]> {
        if (!isObject(classes)) return signal([]);

        const rules: [string, Signal<string[][]>][] = Object.entries(
            classes,
        ).map(
            ([cssSelector, value]: [string, IDatiqRulesData<string[]>[]]): [
                string,
                Signal<string[][]>,
            ] => {
                return [cssSelector, this._rule.evaluateRules<string[]>(value)];
            },
        );

        return computed(() => {
            return rules.reduce(
                (
                    acc: [string, string[]][],
                    [cssSelector, signal]: [string, Signal<string[][]>],
                ): [string, string[]][] => {
                    return [...acc, [cssSelector, uniq(flatten(signal()))]];
                },
                [],
            );
        });
    }
}
